var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerSpecific(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC8757;}\n\t.st1{opacity:0.4;fill:#FFE9D9;enable-background:new    ;}\n\t.st2{opacity:0.2;fill:#FFE9D9;enable-background:new    ;}\n\t.st3{fill:#FFDC91;}\n\t.st4{fill:#FFB900;}\n\t.st5{fill:#FF3E6D;}\n\t.st6{opacity:0.5;fill:#CED5E3;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "271.9,186.3 148,114.7 23.9,186.3 23.9,263.4 148,335 271.9,263.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "271.9,186.3 148,114.7 23.9,186.3 148,257.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "23.9,186.3 23.9,263.4 148,335 148,257.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148,257.9 148,335 271.9,263.4 271.9,186.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.6,201.3 32.6,258.4 139.2,320 139.2,262.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.6,254.9 32.6,258.4 139.2,320 139.2,313.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.6,208.4 32.6,258.4 38.6,254.9 38.6,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.6,219.8 32.6,201.3 32.6,208.4 126.2,312.4 139.2,320 139.2,302.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "139.2,313 45.7,208.9 32.6,201.3 32.6,208.4 126.2,312.4 139.2,320  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.2,201.3 263.2,258.4 156.6,320 156.6,262.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "257.2,254.9 263.2,258.4 156.6,320 156.6,313.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "257.2,254.9 263.2,258.4 156.6,320 156.6,313.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.2,208.4 263.2,258.4 257.2,254.9 257.2,215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231.2,219.8 263.2,201.3 263.2,208.4 169.7,312.4 156.6,320 156.6,302.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.6,313 250.1,208.9 263.2,201.3 263.2,208.4 169.7,312.4 156.6,320  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "250.1,208.9 231.2,219.8 156.6,302.8 156.6,320 156.6,313  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "271.9,106.5 148,35 23.9,106.5 23.9,183.7 148,255.2 271.9,183.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "23.9,106.5 23.9,183.7 148,255.2 148,178.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148,178.1 148,255.2 271.9,183.7 271.9,106.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.6,121.6 32.6,178.7 139.2,240.2 139.2,183.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.6,175.2 32.6,178.7 139.2,240.2 139.2,233.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.6,128.6 32.6,178.7 38.6,175.2 38.6,135.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.6,140.1 32.6,121.6 32.6,128.6 126.2,232.7 139.2,240.2 139.2,223.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "139.2,233.2 45.7,129.1 32.6,121.6 32.6,128.6 126.2,232.7 139.2,240.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.2,121.6 263.2,178.7 156.6,240.2 156.6,183.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "257.2,175.2 263.2,178.7 156.6,240.2 156.6,233.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "257.2,175.2 263.2,178.7 156.6,240.2 156.6,233.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.2,128.6 263.2,178.7 257.2,175.2 257.2,135.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231.2,140.1 263.2,121.6 263.2,128.6 169.7,232.7 156.6,240.2 156.6,223.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.6,233.2 250.1,129.1 263.2,121.6 263.2,128.6 169.7,232.7 156.6,240.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "250.1,129.1 231.2,140.1 156.6,223.1 156.6,240.2 156.6,233.2  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "359,228.2 298.5,193.1 237.9,227.8 237.8,285.6 298.3,320.7 358.8,286  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "237.9,227.8 237.8,285.6 298.3,320.7 298.5,263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "276.5,294.6 276.5,302.7 293.4,312.5 293.4,304.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "298.5,263 298.3,320.7 358.8,286 359,228.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "275.1,206.5 261.3,214.4 321.7,249.6 321.6,275.9 335.6,267.9 335.6,241.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "321.7,249.6 321.6,275.9 335.6,267.9 335.6,241.6  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "158.5,322.7 218.9,357.5 279.6,322.6 279.6,264.8 219.1,229.9 158.5,264.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.9,299.8 218.9,357.5 279.6,322.6 279.6,264.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "223.9,341.2 223.9,349.3 240.8,339.5 240.8,331.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "158.5,264.8 158.5,322.7 218.9,357.5 218.9,299.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.8,278.3 181.8,304.6 195.7,312.6 195.7,286.3 256.3,251.3 242.4,243.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "181.8,278.3 181.8,304.6 195.7,312.6 195.7,286.3  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.5,235 272.9,269.9 333.5,234.9 333.5,177.1 273.1,142.2 212.5,177.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.9,212.1 272.9,269.9 333.5,234.9 333.5,177.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "277.9,253.6 277.9,261.6 294.8,251.9 294.8,243.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "212.5,177.2 212.5,235 272.9,269.9 272.9,212.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "235.8,190.7 235.8,217 249.7,225 249.7,198.7 310.2,163.7 296.4,155.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "235.8,190.7 235.8,217 249.7,225 249.7,198.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerSpecific);
export default __webpack_public_path__ + "static/media/container-specific.ae22ccde1dafac58c628b0593616977c.svg";
export { ForwardRef as ReactComponent };